/* eslint-disable react/jsx-props-no-spreading */
import React, { PureComponent } from 'react';
import { Layout } from 'antd';
import Animate from 'rc-animate';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GlobalHeader from '../components/GlobalHeader';
import TopNavHeader from '../components/TopNavHeader';
import logoText from '../assets/logoText.svg';
import styles from './Header.module.less';

const { Header } = Layout;

class HeaderView extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    bannerVisible: PropTypes.bool.isRequired,
    autoHideHeader: PropTypes.bool.isRequired,
    fixedHeader: PropTypes.bool.isRequired,
    collapsed: PropTypes.bool.isRequired,
    setting: PropTypes.object.isRequired,
    handleMenuCollapse: PropTypes.func.isRequired,
    menuData: PropTypes.array.isRequired,
    logo: PropTypes.string.isRequired,
    logoText: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  state = {
    visible: true,
  };

  static getDerivedStateFromProps(props, state) {
    if (!props.autoHideHeader && !state.visible) {
      return {
        visible: true,
      };
    }
    return null;
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handScroll, { passive: true });
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handScroll);
  }

  getHeadWidth = () => {
    const { isMobile, collapsed, setting } = this.props;
    const { fixedHeader, layout } = setting;
    if (isMobile || !fixedHeader || layout === 'topmenu') {
      return '100%';
    }
    return collapsed ? 'calc(100% - 80px)' : 'calc(100% - 200px)';
  };

  handScroll = () => {
    const { autoHideHeader } = this.props;
    const { visible } = this.state;
    if (!autoHideHeader) {
      return;
    }
    const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
    if (!this.ticking) {
      requestAnimationFrame(() => {
        if (this.oldScrollTop > scrollTop) {
          this.setState({
            visible: true,
          });
          this.scrollTop = scrollTop;
          return;
        }
        if (scrollTop > 300 && visible) {
          this.setState({
            visible: false,
          });
        }
        if (scrollTop < 300 && !visible) {
          this.setState({
            visible: true,
          });
        }
        this.oldScrollTop = scrollTop;
        this.ticking = false;
      });
    }
    this.ticking = false;
  };

  render() {
    const { isMobile, handleMenuCollapse, setting, bannerVisible } = this.props;
    const { navTheme, layout, fixedHeader } = setting;
    const { visible } = this.state;
    const isTop = layout === 'topmenu';
    const HeaderDom = visible ? (
      <Header
        className={fixedHeader ? styles.fixedHeader : styles.staticHeader}
        style={{ marginTop: bannerVisible ? '56px' : '0' }}
      >
        {isTop && !isMobile ? (
          <TopNavHeader
            logoText={logoText}
            theme={navTheme}
            mode="horizontal"
            onCollapse={handleMenuCollapse}
            {...this.props}
          />
        ) : (
          <GlobalHeader
            onCollapse={handleMenuCollapse}
            bannerVisible={bannerVisible}
            {...this.props}
          />
        )}
      </Header>
    ) : null;
    return (
      <Animate component="" transitionName="fade">
        {HeaderDom}
      </Animate>
    );
  }
}

export default connect(({ menu, userSettings }) => ({
  collapsed: menu.collapsed,
  bannerVisible: menu.bannerVisible,
  setting: userSettings.ui,
  userSettings,
}))(HeaderView);
